import NewsHomePage from "./components/NewsHomePage.vue";
import NewsDetailPage from "./components/NewsDetailPage.vue";
export default {
  children: [
    {
      path: "",
      name: "news-home",
      component: NewsHomePage,
       meta: { countViews: true }
    },
    {
      path: ":id",
      name: "news-detail",
      component: NewsDetailPage,
      props: true,
       meta: { countViews: true }
    },
  ],
};